(function () {
  'use strict';

  function initCategoryBar(root) {
    var list = root.querySelector('.lh_category-list');
    var nextBtn = root.querySelector('.lh_category-next');
    if (!list) return;

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var step = list.clientWidth * 0.85;
        list.scrollBy({ left: step, behavior: 'smooth' });
      });
    }

    if (window.matchMedia('(min-width: 1201px)').matches) {
      var dragging = false;
      var startX = 0;
      var scrollLeft = 0;

      list.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        dragging = true;
        startX = e.pageX - list.offsetLeft;
        scrollLeft = list.scrollLeft;
        list.classList.add('is-dragging');
      });

      window.addEventListener('mouseup', function () {
        dragging = false;
        list.classList.remove('is-dragging');
      });

      list.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        e.preventDefault();
        var x = e.pageX - list.offsetLeft;
        list.scrollLeft = scrollLeft - (x - startX) * 1.2;
      });
    }
  }

  function initSliderNav(section) {
    var slider = section.querySelector('[data-tp-slider]');
    if (!slider) return;
    var prev = section.querySelector('[data-tp-prev]');
    var next = section.querySelector('[data-tp-next]');
    if (!prev || !next) return;

    function update() {
      var max = slider.scrollWidth - slider.clientWidth - 2;
      prev.disabled = slider.scrollLeft <= 2;
      next.disabled = slider.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      slider.scrollBy({ left: -slider.clientWidth * 0.8, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      slider.scrollBy({ left: slider.clientWidth * 0.8, behavior: 'smooth' });
    });
    slider.addEventListener('scroll', update, { passive: true });
    update();
  }

  function boot() {
    document.querySelectorAll('.lh_category.tp-category').forEach(initCategoryBar);
    document.querySelectorAll('[data-tekporten-section]').forEach(initSliderNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (el.querySelector('.lh_category.tp-category')) {
      initCategoryBar(el.querySelector('.lh_category.tp-category') || el);
    }
    if (el.matches('[data-tekporten-section]') || el.querySelector('[data-tekporten-section]')) {
      initSliderNav(el.matches('[data-tekporten-section]') ? el : el.querySelector('[data-tekporten-section]'));
    }
  });
})();
